// extracted by mini-css-extract-plugin
export default {"latlng":"Latlng_latlng__iDpmo"};